import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State } from './types';

const state: State = {
  userGroupToken: '',
  loading: false,
  exploError: false
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
